export const PendingApproval = {
    Creators: 'creators',
    Content: 'content'
};



// WEBPACK FOOTER //
// ./approval_queues/constants.js